import { useEffect } from "react";
import usePleaseWait from "../hooks/usePleaseWait";
import useWebData from "../hooks/useWebData";

export const PleaseWaitPopup = () => {
    const { webData }: any = useWebData();
    const { pleasWaitPopup }: any = usePleaseWait();

    useEffect(() => {
        if (pleasWaitPopup) {
            document.body.classList.add('overflow-hidden');
        } else {
            document.body.classList.remove('overflow-hidden');
        }

        return () => document.body.classList.remove('overflow-hidden');
    }, [pleasWaitPopup]);

    if (!pleasWaitPopup) return null;


    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center"
            style={{
                backgroundColor: webData?.websiteHeaderColor,
                opacity: 0.6
            }}
        >
            <div className="text-center w-40 h-40">
                <div className="flex justify-center mb-4">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 200 200"
                    >
                        <circle
                            fill="none"
                            strokeOpacity="1"
                            stroke="#FFFFFF"
                            strokeWidth=".5"
                            cx="100"
                            cy="100"
                            r="0"
                        >
                            <animate attributeName="r" calcMode="spline" dur="2" values="1;80" keyTimes="0;1" keySplines="0 .2 .5 1" repeatCount="indefinite"></animate>
                            <animate attributeName="stroke-width" calcMode="spline" dur="2" values="0;25" keyTimes="0;1" keySplines="0 .2 .5 1" repeatCount="indefinite"></animate>
                            <animate attributeName="stroke-opacity" calcMode="spline" dur="2" values="1;0" keyTimes="0;1" keySplines="0 .2 .5 1" repeatCount="indefinite"></animate>
                        </circle>
                    </svg>
                </div>
            </div>
        </div>
    )
}